import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage} from "react-intl";

import TopProductMobileRow from "./components/TopProductMobileRow";

import TopTableLoader from "../../../TopTablesComponents/TopTableLoader";

import {greyishBlue500} from "assets/jss/main";

TopProductListMobile.propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool
};

function TopProductListMobile({data, loading}) {
    if (loading) {
        return <TopTableLoader />
    }

    if (!data?.lineItems?.length) {
        return (
            <div style={{ color: greyishBlue500, fontSize: "14px", padding: "32px 0", textAlign: "center" }}>
                <FormattedMessage id="dashboard.productsRanking.table.no_result" />
            </div>
        );
    }

    return data.lineItems.map((product, index) => (
        <TopProductMobileRow
            key={index}
            product={product}
            rank={index + 1}
        />
    ));
}

export default TopProductListMobile;
